import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import dayjs from "dayjs";

import { LoadingOverlay, useLineMgmContext } from "@/apps/@components";
import { api } from "@/apps/@utils";

export default function MgmGuard() {
    const { isAction, isNewFriend, customData } = useLineMgmContext();
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("visitor_id") || isAction === false) {
            setIsMounted(true);
            return;
        }
        (async () => {
            try {
                (await api.post("/logs/line-mgm", {
                    visitor_id: localStorage.getItem("visitor_id"),
                    subject: customData.subject,
                    from: customData.from,
                    inviter_id: customData.inviter,
                    is_new_friend: isNewFriend,
                    custom_data: customData,
                    ts: dayjs().unix(),
                })).data;

                if (customData.subject === "bon-bon") {
                    window.location.href = process.env.REACT_APP_BON_BON_REDIRECT;
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                setIsMounted(true);
            }
        })();
    }, [isAction, isNewFriend]);

    return isMounted ? <Outlet /> : <LoadingOverlay visible={true} />
}


// $actionUrl = config('services.line.liffUrl') . '/line-oauth?_target_url='.config('services.line.liffUrl').'?custom_data=subject@bon-bon,from@share-module,inviter@'.$user->id;
// https://liff.line.me/2004306727-rl2aDaOe/line-oauth?_target_url=https://liff.line.me/2004306727-rl2aDaOe?custom_data=subject@bon-bon,from@share-module,inviter@1
